const DOMAIN_REGEX = /^(.+)@([\w.]+)(.+)?$/i;

export default class ExtractDomainFilter {

    static factory() {
        'ngInject';
        const f = new ExtractDomainFilter();
        return f.filter.bind(f);
    }

    filter(node) {
        const matches = DOMAIN_REGEX.exec(decodeURIComponent(node));
        return matches && matches.length > 1 ? { identity: matches[1], domain: matches[2] } : {};
    }
}
